import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=33c3ca28"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c3ca28')) {
      api.createRecord('33c3ca28', component.options)
    } else {
      api.reload('33c3ca28', component.options)
    }
    module.hot.accept("./Story.vue?vue&type=template&id=33c3ca28", function () {
      api.rerender('33c3ca28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Story.vue"
export default component.exports